import React from 'react'
import PropTypes from 'prop-types'
import { SearchTable } from 'components/SearchTable'
import { Icon } from 'antd'

const handleSearch = (selectedKeys, confirm) => () => {
  confirm()
}

const handleReset = clearFilters => () => {
  clearFilters()
}

const camelCase = (str) =>
  str.toLowerCase().replace(
    /\W+(.)/g,
    (match, chr) => chr.toUpperCase()
  )

export function TableCol({ title = null, dataIndex = null, key = null, filters = null, filter = null, sort = null, render = null, width = null, ellipsis = null }) {
  let searchInput

  let tableCol = {
    title: title,
    dataIndex: dataIndex || key || camelCase(title),
    key: key || camelCase(title),
    sorter: sort,
    render: render,
    width,
    ellipsis,
  }
  if (filters) {
    tableCol = {
      ...tableCol,
      filters: filters,
      onFilter: filter,
    }
  } else if (filter) {
    tableCol = {
      ...tableCol,
      filterDropdown: ({
        // eslint-disable-next-line react/prop-types
        setSelectedKeys, selectedKeys, confirm, clearFilters,
      }) => (
        <SearchTable
          onSetRef={e => (searchInput = e)}
          onSetSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          onSearch={handleSearch}
          onReset={handleReset}
        />
      ),
      filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
      onFilter: filter,
      onFilterDropdownVisibleChange: visible => visible && setTimeout(() => searchInput.focus())
    }
  }
  return tableCol
}

TableCol.propTypes = {
  title: PropTypes.string,
  key: PropTypes.string,
  search: PropTypes.func,
  sort: PropTypes.func,
  dataIndex: PropTypes.string,
  width: PropTypes.string
}
